module.exports = __webpack_public_path__ + "assets/img/provider-01.ae0553f4.jpg";